import { PaymentType } from '@spartacus/cart/base/root';
import { CustomCheckoutActions } from '../actions';
import { PaymentTypesState } from '../custom-checkout-state';

export const initialState: PaymentTypesState = {
  entities: {},
  selected: '',
};

export function reducer(
  state = initialState,
  action:
    CustomCheckoutActions.CustomPaymentTypesAction,
): PaymentTypesState {
  switch (action.type) {
    case CustomCheckoutActions.LOAD_PAYMENT_TYPES_SUCCESS: {
      state = initialState;
      const paymentTypes: PaymentType[] = action.payload;
      const entities = paymentTypes.reduce(
        (
          paymentTypesEntities: { [code: string]: PaymentType },
          name: PaymentType
        ) => {
          return {
            ...paymentTypesEntities,
            [name.code]: name,
          };
        },
        {
          ...state.entities,
        }
      );

      return {
        ...state,
        entities,
      };
    }

    case CustomCheckoutActions.SET_PAYMENT_TYPE_SUCCESS: {
      return {
        ...state,
        selected: action.payload.paymentMode.code,
      };
    }
  }

  return state;
}

export const getPaymentTypesEntites = (state: PaymentTypesState) =>
  state.entities;
export const getSelectedPaymentType = (state: PaymentTypesState) =>
  state.selected;
